/* eslint-disable prefer-rest-params, func-names */

// google translate is causing React to crash, this is not being handled either by
// React or google.
//
// Dan Abramov recommend using this code snippet. Read more about this on google and
// React issue pages linked below.
//
// https://bugs.chromium.org/p/chromium/issues/detail?id=872770
// https://github.com/facebook/react/issues/11538#issuecomment-417504600
//
// Jira: https://hmgroup.atlassian.net/browse/COWEB-918?atlOrigin=eyJpIjoiYTBkMzdmODIwZmIwNGRmYjlmYjdjM2Y3NTIzOGExOGMiLCJwIjoiaiJ9

export default (): any => {
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild
    Node.prototype.removeChild = function (child) {
      if (child.parentNode !== this) {
        return child
      }
      return originalRemoveChild.apply(this, arguments)
    }

    const originalInsertBefore = Node.prototype.insertBefore
    Node.prototype.insertBefore = function (newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        return newNode
      }
      return originalInsertBefore.apply(this, arguments)
    }
  }
}
